import * as React from 'react';
import styles from './alert-info.scss';

export interface AlertInfoProps {
  text: string;
  children?: React.ReactNode;
  className?: string;
}

export const AlertInfo = ({ text, children = null, className = '' }: AlertInfoProps) =>
  <div className={`col-md-12 ${className}`}>
    <div className={styles.alertInfo}>
      {text ? <p>{text}</p> : null}
      {children}
    </div>
  </div>;
